"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const PageCollection = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement("g", { id: "page-collection" }, /* @__PURE__ */ React.createElement(
      "path",
      {
        id: "Subtract",
        d: "M7 3C5.34315 3 4 4.34315 4 6V18C4 19.6569 5.34315 21 7 21H18C19.3062 21 20.4175 20.1652 20.8293 19H7C6.44772 19 6 18.5523 6 18V6C6 5.44772 6.44772 5 7 5H9V3H7Z",
        fill: "#8790A6"
      }
    ), /* @__PURE__ */ React.createElement("g", { id: "Vector", opacity: 0.6 }, /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M21 4.5C21 5.32843 20.3284 6 19.5 6C18.6716 6 18 5.32843 18 4.5C18 3.67157 18.6716 3 19.5 3C20.3284 3 21 3.67157 21 4.5Z",
        fill: "#8790A6"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M21 9.5C21 10.3284 20.3284 11 19.5 11C18.6716 11 18 10.3284 18 9.5C18 8.67157 18.6716 8 19.5 8C20.3284 8 21 8.67157 21 9.5Z",
        fill: "#8790A6"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M21 14.5C21 15.3284 20.3284 16 19.5 16C18.6716 16 18 15.3284 18 14.5C18 13.6716 18.6716 13 19.5 13C20.3284 13 21 13.6716 21 14.5Z",
        fill: "#8790A6"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M16 9.5C16 10.3284 15.3284 11 14.5 11C13.6716 11 13 10.3284 13 9.5C13 8.67157 13.6716 8 14.5 8C15.3284 8 16 8.67157 16 9.5Z",
        fill: "#8790A6"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M16 4.5C16 5.32843 15.3284 6 14.5 6C13.6716 6 13 5.32843 13 4.5C13 3.67157 13.6716 3 14.5 3C15.3284 3 16 3.67157 16 4.5Z",
        fill: "#8790A6"
      }
    )))
  );
};
export default PageCollection;
